import React from 'react';
import Icon from '../../../components/AppIcon';

/**
 * Shared heading block for every registration step — one type scale, one rhythm.
 * `eyebrow` is optional context above the title (e.g. "Step 2 of 6").
 */
export const StepHeader = ({ title, description, eyebrow, children }) => (
  <header className="mb-8 border-b border-border pb-6">
    {eyebrow && (
      <p className="mb-1 text-xs font-semibold uppercase tracking-[0.12em] text-primary">{eyebrow}</p>
    )}
    <h2 id="current-step-heading" className="text-2xl font-semibold tracking-tight text-foreground [text-wrap:balance]">{title}</h2>
    {description && <p className="mt-1.5 max-w-2xl text-[15px] leading-relaxed text-text-secondary">{description}</p>}
    {children}
  </header>
);

/**
 * Quiet inline note under a step heading. Replaces the old emoji "Tip" boxes.
 * tone: "info" (default) | "success"
 */
export const StepNote = ({ children, tone = 'info', icon }) => {
  const tones = {
    info: 'border-primary/20 bg-primary/5 text-foreground',
    success: 'border-success/25 bg-success/5 text-foreground',
  };
  const icons = { info: 'Info', success: 'CheckCircle2' };
  const iconTone = { info: 'text-primary', success: 'text-success' };
  return (
    <div className={`mt-4 flex items-start gap-3 rounded-lg border px-4 py-3 text-sm leading-relaxed ${tones[tone]}`}>
      <Icon name={icon || icons[tone]} size={18} className={`mt-0.5 flex-shrink-0 ${iconTone[tone]}`} />
      <p className="text-text-secondary">{children}</p>
    </div>
  );
};

export default StepHeader;
